import React from 'react';
import { X, Check } from 'lucide-react';
const comparisons = [{
  title: 'Alumnos que se aburren y no vuelven',
  sin: 'Repetís siempre lo mismo porque no tenés más recursos y perdés alumnos sin entender por qué',
  con: 'Sistema completo de fidelización con estrategias concretas para que tus alumnos quieran seguir viniendo mes a mes'
}, {
  title: 'Querés aumentar tus precios pero no te animás',
  sin: 'No tenés un sistema visible que justifique cobrar más por tus clases',
  con: 'Guía completa para profesionalizar tu imagen, estructurar tus servicios y justificar un aumento real de precios'
}, {
  title: 'Querés abrir tu propio espacio o dictar talleres',
  sin: 'No sabés por dónde empezar, qué necesitás ni cómo organizarte',
  con: 'Sistema paso a paso para armar talleres intensivos, clases privadas y tu propio espacio de ritmos latinos'
}, {
  title: 'Alumnos estancados que no avanzan hace meses',
  sin: 'No sabés si es técnica, motivación o metodología y no tenés herramientas para diagnosticarlo',
  con: 'Protocolo de diagnóstico y plan de acción concreto para destrabar el progreso de cualquier alumno'
}, {
  title: 'Querés diferenciarte de todos los instructores de tu zona',
  sin: 'Das clases como todos, sin identidad ni metodología propia visible',
  con: 'Sistema para crear tu propio método de enseñanza con identidad, nombre y estructura profesional'
}];
export function ProAvanzadoSection() {
  return <section className="py-12 md:py-24 bg-neutral-900 border-y border-neutral-800" data-id="element-236">
      <div className="container mx-auto px-4" data-id="element-237">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-238">
          <h2 className="text-2xl md:text-5xl font-black text-white mb-2 md:mb-4" data-id="element-239">
            ¿QUÉ AGREGA EL RITMOS PRO AVANZADO™?
          </h2>
          <p className="text-base md:text-xl text-amber-500 font-medium" data-id="element-240">
            El sistema para profes que quieren ir un paso más allá
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4 md:space-y-8 mb-8 md:mb-16" data-id="element-241">
          {comparisons.map((item, index) => <div key={index} className="bg-neutral-950 rounded-xl md:rounded-2xl p-4 md:p-8 border border-neutral-800" data-id="element-242">
              <h3 className="text-base md:text-xl font-bold text-white mb-3 md:mb-6 text-center" data-id="element-243">
                {item.title}
              </h3>
              <div className="grid grid-cols-2 gap-3 md:gap-6" data-id="element-244">
                <div className="bg-red-950/20 p-3 md:p-5 rounded-lg md:rounded-xl border border-red-900/30" data-id="element-245">
                  <div className="flex items-center gap-1.5 text-red-400 font-bold mb-1.5 md:mb-3 text-xs md:text-base" data-id="element-246">
                    <X className="w-4 h-4" data-id="element-247" /> SIN:
                  </div>
                  <p className="text-neutral-400 text-xs md:text-sm leading-snug" data-id="element-248">
                    {item.sin}
                  </p>
                </div>
                <div className="bg-amber-950/20 p-3 md:p-5 rounded-lg md:rounded-xl border border-amber-900/30" data-id="element-249">
                  <div className="flex items-center gap-1.5 text-amber-400 font-bold mb-1.5 md:mb-3 text-xs md:text-base" data-id="element-250">
                    <Check className="w-4 h-4" data-id="element-251" /> CON:
                  </div>
                  <p className="text-neutral-300 text-xs md:text-sm leading-snug font-medium" data-id="element-252">
                    {item.con}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-r from-amber-900/40 to-neutral-900 border border-amber-500/30 rounded-xl md:rounded-2xl p-5 md:p-8 text-center" data-id="element-253">
          <h3 className="text-lg md:text-2xl font-black text-white mb-4 md:mb-6" data-id="element-254">
            RITMOS PRO AVANZADO™ INCLUYE:
          </h3>
          <div className="space-y-3 md:space-y-4 text-left" data-id="element-255">
            <div className="flex items-start gap-3 bg-neutral-950/50 p-3 md:p-4 rounded-lg md:rounded-xl" data-id="element-256">
              <div className="bg-amber-500 text-neutral-950 font-black w-7 h-7 md:w-8 md:h-8 rounded flex items-center justify-center shrink-0 text-sm" data-id="element-257">
                1
              </div>
              <div data-id="element-258">
                <h4 className="font-bold text-white text-sm md:text-base mb-0.5" data-id="element-259">
                  Módulo 1 — Sistema de Fidelización de Alumnos
                </h4>
                <p className="text-neutral-400 text-xs md:text-sm" data-id="element-260">
                  convertí alumnos ocasionales en alumnos de por vida
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 bg-neutral-950/50 p-3 md:p-4 rounded-lg md:rounded-xl" data-id="element-261">
              <div className="bg-amber-500 text-neutral-950 font-black w-7 h-7 md:w-8 md:h-8 rounded flex items-center justify-center shrink-0 text-sm" data-id="element-262">
                2
              </div>
              <div data-id="element-263">
                <h4 className="font-bold text-white text-sm md:text-base mb-0.5" data-id="element-264">
                  Módulo 2 — Sistema de Monetización del Instructor
                </h4>
                <p className="text-neutral-400 text-xs md:text-sm" data-id="element-265">
                  convertí tu conocimiento en múltiples fuentes de ingreso
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}